// Precio por peso para retail. `items.price` es el precio CARD por unidad de
// medida (kg/lb/g). El cash price aplica el mismo descuento que el resto del POS.

export function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100
}

export function weightLineTotals(
  cardPricePerUnit: number,
  weight: number,
  cashPct: number
): { card: number; cash: number } {
  const card = round2(cardPricePerUnit * weight)
  const cash = round2(card * (1 - cashPct))
  return { card, cash }
}
